<template>
  <div class="customer-all-info">
            <div class="info-item" v-for="(info, index) in attributeList" :key="index">
              <!-- <el-tooltip class="item" effect="light" :content="info.name" placement="bottom-end"> -->
                <span :title="info.name">{{ info.name }}</span>
              <!-- </el-tooltip> -->
              <span
                :title="customer[info.identity]"
                v-if="info.type === 'input' || 
                info.type === 'select' ||
                info.type === 'number' ||
                info.type === 'dateTimePicker' ||
                info.type === 'dict'
                ">
                      {{ customer[info.identity] }}
              </span>
              <span
                :title="customer[info.identity + '_text']"
                v-if="info.type === 'addressPicker'">
                  {{ customer[info.identity + '_text'] }}
                  <!-- <span v-if="customer[info.identity] === null">
                    {{ customer[info.identity + '_text'] }}
                  </span> -->
                  <!-- <el-tooltip
                    v-if="customer[info.identity + '_text'] !== null"
                    class="item-poper"
                    effect="light"
                    :content="customer[info.identity + '_text']"
                    placement="bottom-end">
                    <span>
                      {{ customer[info.identity + '_text'] }}
                    </span>
                  </el-tooltip> -->
              </span>
              
              <span
                :title="customer[info.identity + 'multipleSelect']"
                v-if="info.type === 'multipleSelect'">
                <!-- <span v-if="customer[info.identity] === null">
                  {{ customer[info.identity + 'multipleSelect'] }}
                </span> -->
                <!-- <el-tooltip
                  v-if="customer[info.identity + 'multipleSelect'] !== null"
                  class="item-poper"
                  effect="light"
                  :content="customer[info.identity + 'multipleSelect']"
                  placement="bottom-end">
                  <span> -->
                    {{ customer[info.identity + 'multipleSelect'] }}
                  <!-- </span> -->
                <!-- </el-tooltip> -->
              </span>
            </div>
          </div>
</template>

<script>
export default {
  name: 'customer-profile',
  props: ['attributeList', 'customer'],
  data() {
    return {
    }
  },
  
}
</script>

<style scoped>
.customer-all-info{
  height: 600px;
  overflow: auto;
  margin-top: 10px;
}
.info-item {
  width: calc(100% - 46px);
  min-width:25px;
  margin: 0 auto;
  height: 36px;
  line-height: 36px;
  color: #333;
  font-size: 12px;
  border-bottom: 1px solid #E7E7E7;
  display: flex;
  justify-content: space-between;
}
.info-item>span {
  min-width: 65px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
.info-item span:nth-child(2){
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  text-align: right;
}
</style>
